import script from "./OldModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OldModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__